import _ from 'lodash';

import { LINKS, URLS } from '@/constants';
import constructSlug from '@/utils/construct-slug';

const EXCLUDED_URLS = [URLS.SITEMAP];
const PAGES = _.filter(
  [...LINKS.PRIMARY, ...LINKS.SECONDARY, ...LINKS.TERMS_AND_PRIVACY],
  ({ url }) => !_.includes(EXCLUDED_URLS, url)
);

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'safetyFeaturesEntries' does not exist on type '{}'.
const generateSitemap = ({ safetyFeaturesEntries, vehicleMakesEntries } = {}) => {
  const siteMapItems = {
    primary: _.map(PAGES, (item) => {
      // Manually insert the nested safety features
      if (item.url === URLS.SAFETY_FEATURES_LISTING && !_.isEmpty(safetyFeaturesEntries)) {
        return {
          ...item,
          children: safetyFeaturesEntries,
        };
      }

      return item;
    }),
    vehicleMakesEntries: _.map(vehicleMakesEntries, (item) => {
      return {
        title: item.title,
        url: '/[make]',
        as: `/${constructSlug(item.uri)}`,
      };
    }),
  };

  return siteMapItems;
};

export default generateSitemap;
